module.exports = __webpack_public_path__ + "static/media/ss10_preview.372c7db2.jpg";